import { GridColDef } from '@mui/x-data-grid';
import { ethers } from 'ethers';
import { capitalize } from 'lodash';
import * as React from 'react';
import { tokenDecimals } from '../../../helpers/config/contracts.config';
import { txExplorersPrefixes } from '../../../helpers/config/explorers';
import { compactTxHash, formatCurrencyAmount } from '../../../helpers/formatters';
import { renderDateTime } from './position-columns';
import dayjs from 'dayjs';

interface IParamsForActivityColumns {
    activityType: 'withdraw' | 'deposit';
}

export function getStatusClass(status: string) {
    switch (status) {
        case 'CONFIRMED':
        case 'DONE':
            return 'nereus-color-status-up';
        case 'PENDING':
            return 'nereus-color-status-warning';
        case 'FAILED':
            return 'nereus-color-status-down';
        default:
            return '';
    }
}

export const maxConfirmations = Number(process.env.REACT_APP_NEED_NETWORK_CONFIRMATIONS) || 10;

export function getActivityColumns({ activityType }: IParamsForActivityColumns) {

    const columnConfig: Record<string, GridColDef> = {
        txHash: {
            field: 'txHash', headerName: 'Tx hash', width: 200,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) =>params.row.txHash ? <a className="nereus-color-main" href={`${txExplorersPrefixes.base}/${params.row.txHash}`} target="_blank" rel="noreferrer noopemer">{compactTxHash(params.row.txHash)}</a> : ''
        },
        withdrawTx: {
            field: 'withdrawTx', headerName: 'Tx hash', width: 200,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) =>params.row.withdrawTx ? <a className="nereus-color-main" href={`${txExplorersPrefixes.base}/${params.row.withdrawTx}`} target="_blank" rel="noreferrer noopemer">{compactTxHash(params.row.withdrawTx)}</a> : ''

        },
        type: {
            field: 'type', headerName: 'Trx type', width: 120,
            valueGetter: () => capitalize(activityType),
        },
        date: {
            field: 'date', headerName: 'Date',
            width: 100,
            align: 'right',
            headerAlign: 'right',
            flex: 1,
            valueGetter: (params) => dayjs(params.row.createdAt).valueOf(),
            renderCell: (params) => renderDateTime(params.row.createdAt)
        },
        amount: {
            flex: 1,
            align: 'right',
            headerAlign: 'right',
            field: 'amount', headerName: 'Trx amount', width: 120,
            valueGetter: (params) => parseInt(params.row.amount),
            renderCell: (params) => formatCurrencyAmount(ethers.utils.formatUnits(params.row.amount, tokenDecimals.usdc), 'USDC')
        },
        confirmations: {
            flex: 1,
            align: 'right',
            headerAlign: 'right',
            field: 'confirmations', headerName: 'Confirmations', width: 120,
            renderCell: (params) => {

                let confirmations = params.row.blockProcessed - params.row.blockFound
                if (confirmations > maxConfirmations) {
                    confirmations = maxConfirmations
                }
                return <span className={getStatusClass(params.row.status)}>{`${confirmations}/${maxConfirmations}`}</span>;
            }
        },
        status: {
            align: 'right',
            headerAlign: 'right',
            field: 'status',
            headerName: 'Status',
            width: 120,
            renderCell: params => {
                return <span className={getStatusClass(params.row.status)}>{capitalize(params.row.status)}</span>
            },
        }
    };

    const columnsByType = {
        deposit: [
            'type',
            'date',
            'amount',
            'status',
            'txHash',
            'confirmations'
        ],
        withdraw: [
            'type',
            'date',
            'amount',
            'withdrawTx',
            'status'
        ]
    };

    return columnsByType[activityType].map((columnKey) => columnConfig[columnKey]).filter(Boolean);
}